import { browserName, mobileModel, mobileVendor } from "react-device-detect";
import { posAppId } from "../config/envConfig";
import { APP_ID_KEY, DATA_REFERENCE } from "./Constants";
import Moengage from "@moengage/web-sdk";
import { getAppConfig } from "config/appConfigHelper";
import { flatAndMapEventData, mapEventData } from "./cdp/Constant";

const Util = {
  isWebView() {
    var standalone = window.navigator.standalone,
      userAgent = window.navigator.userAgent.toLowerCase(),
      safari = /safari/.test(userAgent),
      ios = /iphone|ipod|ipad/.test(userAgent);
    if (ios) {
      if (!standalone && safari) {
        // Safari
      } else if (!standalone && !safari) {
        // iOS webview
        return true;
      }
    } else {
      if (userAgent.includes("wv")) {
        // Android webview
        return true;
      } else {
        // Chrome
      }
    }
    return false;
  },
  getUserAgentData(data) {
    let { source, name } = data;
    source = source || "kiosk";
    name = name || "Sign Up";
    let ref = "Kiosk App";

    const referenceData = JSON.parse(localStorage.getItem(DATA_REFERENCE));

    let channel =
      referenceData && referenceData[APP_ID_KEY]
        ? referenceData[APP_ID_KEY]
        : posAppId;

    const qParams = `?source=${source}&name=${name}&channel=${channel}&ref=${ref}`;
    return qParams;
  },
  isIosWebView() {
    let standalone = window.navigator.standalone,
      userAgent = window.navigator.userAgent.toLowerCase(),
      safari = /safari/.test(userAgent),
      ios = /iphone|ipod|ipad/.test(userAgent);
    if (ios) {
      if (!standalone && safari) {
        // Safari
      } else if (!standalone && !safari) {
        // iOS webview
        return true;
      }
    }
    return false;
  },
  isAndroidWebView() {
    let userAgent = window.navigator.userAgent.toLowerCase(),
      ios = /iphone|ipod|ipad/.test(userAgent);
    if (!ios) {
      if (userAgent.includes("wv")) {
        // Android webview
        return true;
      } else {
        // Chrome
      }
    }
    return false;
  },
  getAuthHeaders(category) {
    let region = Intl.DateTimeFormat().resolvedOptions().timeZone;

    let platform = "NA";
    if (this.isWebView()) platform = "App";
    else platform = "Web";

    let os = "NA";
    if (this.isIosWebView()) os = "IOS";
    else if (this.isAndroidWebView()) os = "Android";
    else os = "Web";

    let cat = category || "";
    let deviceName = mobileModel || "";
    let deviceManufacturer = mobileVendor || "";
    let browser = browserName || "";

    let headers = {
      "x-app-region": region,
      "x-app-platform": platform,
      "x-app-category": cat,
      "x-device-name": deviceName,
      "x-device-manufacturer": deviceManufacturer,
      "x-device-operating-system": os,
      "x-device-browser-agent": browser,
    };
    return headers;
  },
  triggerMoEngageEvent(
    eventName,
    data,
    additionalData = {},
    flattenItems = false,
    locationData = {},
  ) {
    try {
      const moEngageEnabled = getAppConfig("MOENGAGE_ENABLED");
      const location = localStorage.getItem("appConfig");
      if (location) {
        const parsedLocation = JSON.parse(location);
        locationData = {
          xAppLocationCode: parsedLocation?.xAppLocationCode || "",
        };
      }

      if (moEngageEnabled) {
        let eventData = {};
        if (flattenItems) {
          eventData = flatAndMapEventData(eventName, data);
        } else {
          eventData = mapEventData(eventName, data);
        }
        eventData = { ...eventData, ...additionalData, ...locationData };

        if (Object.keys(eventData).length === 0) {
          eventData = data;
        }

        if (window.ReactNativeWebView) {
          let reactMsg = JSON.stringify({
            msg: eventName,
            data: eventData || {},
            type: "MoEngageEvent",
          });
          window.ReactNativeWebView.postMessage(reactMsg);
        } else {
          Moengage.track_event(eventName, eventData || {});
        }
        return;
      }
    } catch (e) {
      console.log("Error in triggerMoEngageEvent: ", e);
    }
  },

  sendMessageToReactNative(msg, data) {
    try {
      if (msg.toLowerCase().includes("moengage")) {
        const config = localStorage.getItem("appConfig");
        const parsedConfig = JSON.parse(config);
        let message = msg;

        if (msg.includes("moengage-user")) {
          message = msg.slice(14);
        } else {
          message = msg.slice(9);
        }

        if (parsedConfig.ENVIRONMENT.toLowerCase().includes("dev")) {
          if (window.ReactNativeWebView) {
            let reactMsg = JSON.stringify({
              msg: msg,
              data: data || {},
            });
            window.ReactNativeWebView.postMessage(reactMsg);
          } else {
            Moengage.track_event(message, data || {});
          }
          return;
        }
      }
      if (window.ReactNativeWebView) {
        if (msg !== undefined) {
          window.ReactNativeWebView.postMessage(msg);
        }
      }
    } catch (e) {}
  },
};
export default Util;
